"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationDecoder = exports.GitlabIntegrationDecoder = exports.SlackIntegrationDecoder = exports.GithubIntegrationDecoder = exports.GithubIntegrationOwnerTypeDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var timestamp_1 = __importDefault(require("./timestamp"));
exports.GithubIntegrationOwnerTypeDecoder = ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('User'), ts_data_json_1.JsonDecoder.isExactly('Organization')], 'GithubIntegration.OwnerType');
exports.GithubIntegrationDecoder = ts_data_json_1.JsonDecoder.object({
    service: ts_data_json_1.JsonDecoder.isExactly('github'),
    deleted: ts_data_json_1.JsonDecoder.boolean,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    installationId: ts_data_json_1.JsonDecoder.string,
    ownerType: exports.GithubIntegrationOwnerTypeDecoder,
    ownerName: ts_data_json_1.JsonDecoder.string,
}, 'GithubIntegration');
exports.SlackIntegrationDecoder = ts_data_json_1.JsonDecoder.object({
    service: ts_data_json_1.JsonDecoder.isExactly('slack'),
    deleted: ts_data_json_1.JsonDecoder.boolean,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    author: ts_data_json_1.JsonDecoder.string,
    bot: ts_data_json_1.JsonDecoder.object({
        accessToken: ts_data_json_1.JsonDecoder.string,
        scope: ts_data_json_1.JsonDecoder.string,
        userId: ts_data_json_1.JsonDecoder.string,
    }, 'SlackIntegration.Bot'),
    team: ts_data_json_1.JsonDecoder.object({
        id: ts_data_json_1.JsonDecoder.string,
        name: ts_data_json_1.JsonDecoder.string,
    }, 'SlackIntegration.Team'),
    appId: ts_data_json_1.JsonDecoder.string,
}, 'SlackIntegration');
exports.GitlabIntegrationDecoder = ts_data_json_1.JsonDecoder.object({
    service: ts_data_json_1.JsonDecoder.isExactly('gitlab'),
    deleted: ts_data_json_1.JsonDecoder.boolean,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
}, 'GitlabIntegration');
exports.IntegrationDecoder = ts_data_json_1.JsonDecoder.oneOf([exports.GithubIntegrationDecoder, exports.SlackIntegrationDecoder, exports.GitlabIntegrationDecoder], 'Integration');
